export default __webpack_public_path__ + "static/char-thumb-47-555bbb3131cdde910643d23606e5d7a4.webp";